import { Grid, useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "@/theme";
import { CoverImage } from "@/components/CoverImage";
import { Carousel } from "./carousel/Carousel";
import styled from "@emotion/styled";
import { Square } from "./Square";
import { ImageAttributes } from "@/store";

const GridWrapper = styled.div`
  overflow: hidden;
`;

const GridItem = styled(Grid)`
  width: 100%;
  height: 100%;
`;

export type ImageGridProps = {
  images: ImageAttributes[];
  startAtIndex?: number;
};

export const ImageGrid = ({
  images = [],
  startAtIndex = 0,
}: ImageGridProps) => {
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const imageGridItems = images.map((image: ImageAttributes) => {
    return (
      <GridItem key={image.src} item md={6} lg={3}>
        <Square>
          <CoverImage
            src={image.src}
            alt={image.alt}
            width={image.width}
            height={image.height}
            loading={image.loading}
          />
        </Square>
      </GridItem>
    );
  });
  return isSmallScreen ? (
    <Carousel
      items={imageGridItems}
      dots="none"
      slidePosition="stretch"
      slideGap={false}
      startAtIndex={startAtIndex}
    ></Carousel>
  ) : (
    <GridWrapper>
      <Grid container spacing={3}>
        {imageGridItems}
      </Grid>
    </GridWrapper>
  );
};
